import axios from 'axios';

const base =
  process.env.REACT_APP_BACK_URL ||
  `${window.location.protocol}//${window.location.hostname}:5000`;

const AcontecimientosService = {
  async getAcontecimientosSocios(
    id: number,
    getAccessTokenSilently: () => Promise<string>
  ) {
    try {
      const token = await getAccessTokenSilently();
      const response = await axios.get(
        `${base}/acontecimientos/socio/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error al obtener los acontecimientos del socio:', error);
      throw error;
    }
  },
};

export default AcontecimientosService;
